import { render } from "./PreActionInterestedIn.vue?vue&type=template&id=6f26f256&scoped=true"
import script from "./PreActionInterestedIn.vue?vue&type=script&lang=js"
export * from "./PreActionInterestedIn.vue?vue&type=script&lang=js"

import "./PreActionInterestedIn.vue?vue&type=style&index=0&id=6f26f256&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f26f256"]])

export default __exports__